<template>
  <div>
    <px-view-header title="Detalhes da compra" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link to="/compras">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && compra">
      <px-compra-detalhes-dados-basicos :compra="compra" />
      <px-compra-detalhes-admin :compra="compra" />
      <px-compra-detalhes-comprador :compra="compra" />
      <px-compra-detalhes-produtos :compra="compra" />
    </div>
  </div>
</template>

<script>
import CompraDetalhesDadosBasicos from './CompraDetalhesDadosBasicos.vue';
import CompraDetalhesAdmin from './CompraDetalhesAdmin.vue';
import CompraDetalhesComprador from './CompraDetalhesComprador.vue';
import CompraDetalhesProdutos from './CompraDetalhesProdutos.vue';
import CompraService from '../listagem/service/compras-listagem-service';

export default {
  data() {
    return {
      compraId: this.$route.params.id,
      compra: null,
      loading: false,
      searchText: null,
      selectedSort: null,
      viewType: null,
      breadcrumbs: [
        { text: 'Negócios' },
        {
          text: 'Compras',
          to: '/compras',
        },
        { text: 'Compra' },
      ],
    };
  },
  methods: {
    onChangeSearchText(text) {
      this.searchText = text;
    },
    onChangeSort(sort) {
      this.selectedSort = sort;
    },
    onChangeView(view) {
      this.viewType = view;
    },
    getCotacao() {
      this.loading = true;
      CompraService.getCompra(this.compraId)
        .then((response) => {
          this.compra = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onMovimentarCotacao() {
      this.getCotacao();
    },
  },
  created() {
    this.getCotacao();
  },
  components: {
    pxCompraDetalhesDadosBasicos: CompraDetalhesDadosBasicos,
    pxCompraDetalhesAdmin: CompraDetalhesAdmin,
    pxCompraDetalhesComprador: CompraDetalhesComprador,
    pxCompraDetalhesProdutos: CompraDetalhesProdutos,
  },
};
</script>
